import KiccEasyCardApi from '@apis/easyCard/KiccEasyCardApi';
import kiccEasyCardQueries from '@apis/queries/kiccEasyCardQueries';
import useLoading from '@hooks/ui/useLoading';
import { useFlow } from '@stackflow/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

function useDeleteEasyCard(cardId: string) {
    const { t } = useTranslation('easyCard');
    const queryClient = useQueryClient();
    const { startLoading, stopLoading } = useLoading();
    const { pop } = useFlow();
    const { mutate } = useMutation({
        mutationFn: KiccEasyCardApi.deleteCard,
        onMutate() {
            startLoading();
        },
        onSuccess() {
            queryClient.invalidateQueries({ queryKey: kiccEasyCardQueries._def });
            toast.success(t('delete.success'));
            pop();
        },
        onError(e) {
            console.error(e);
            toast.error(t('delete.error'));
        },
        onSettled() {
            stopLoading();
        },
    });

    const handleDeleteCard = () => {
        mutate(cardId);
    };

    return {
        handleDeleteCard,
    };
}

export default useDeleteEasyCard;
